import { jsx as i } from "react/jsx-runtime";
import { c as x } from "./clsx-OuTLNxxd.js";
const p = "_text_1dzaz_29", o = {
  text: p,
  "is-small": "_is-small_1dzaz_34",
  "is-ellipsis": "_is-ellipsis_1dzaz_38",
  "color-primary": "_color-primary_1dzaz_43",
  "color-secondary": "_color-secondary_1dzaz_46",
  "color-tertiary": "_color-tertiary_1dzaz_49",
  "color-eco-green": "_color-eco-green_1dzaz_52",
  "color-success": "_color-success_1dzaz_55",
  "color-error": "_color-error_1dzaz_58",
  "color-inverted": "_color-inverted_1dzaz_61",
  "color-warning": "_color-warning_1dzaz_64",
  "is-bold": "_is-bold_1dzaz_67",
  "size-xs": "_size-xs_1dzaz_70",
  "size-sm": "_size-sm_1dzaz_73",
  "size-base": "_size-base_1dzaz_76",
  "size-lg": "_size-lg_1dzaz_79",
  "size-xl": "_size-xl_1dzaz_82",
  "dialog-overlay-show": "_dialog-overlay-show_1dzaz_1",
  "dialog-content-show": "_dialog-content-show_1dzaz_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1dzaz_1"
};
function b({
  children: r,
  dangerouslySetInnerHTML: s,
  isSmall: c,
  ellipsis: d,
  isSpan: t,
  className: n = "",
  color: _,
  isBold: m,
  size: a,
  title: g,
  ...z
}) {
  const l = x(
    o.text,
    c && o["is-small"],
    d && o["is-ellipsis"],
    _ && o[`color-${_}`],
    m && o["is-bold"],
    a && o[`size-${a}`],
    n
  ), e = t ? "span" : "div";
  return s ? /* @__PURE__ */ i(e, { className: l, dangerouslySetInnerHTML: s, ...z, title: g }) : /* @__PURE__ */ i(e, { className: l, ...z, children: r });
}
export {
  b as T,
  o as s
};
